var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "workflow-permission" } },
    [
      _c("supsis-table", {
        staticClass: "users-supsis-table",
        attrs: {
          columns: _vm.cols,
          rows: _vm.getFilteredRows(),
          "bottom-pagination": true,
          "pagination-cursor": _vm.paginationCursor,
          options: _vm.tableOptions,
        },
        on: {
          "cursor-changed": function (cursor) {
            return (_vm.paginationCursor = cursor)
          },
        },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function () {
              return [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-content-between align-items-center",
                  },
                  [
                    _c(
                      "div",
                      [
                        _c("a-input-search", {
                          staticClass: "search-input",
                          attrs: {
                            value: _vm.searchText,
                            placeholder: _vm.$t("message.startFilter"),
                          },
                          on: {
                            input: function ($event) {
                              return _vm.searchTextHandle($event)
                            },
                            search: _vm.onSearch,
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _vm.isModalShow
        ? _c(
            "Modal2",
            {
              staticStyle: { width: "400px" },
              attrs: {
                title: _vm.$t("task.userPerm") + _vm.selectedUser.name,
                "show-footer": false,
                "class-name": "modal2",
              },
              on: { cancel: _vm.hideModal },
            },
            [
              _c("div", { staticClass: "permissions-container" }, [
                _c(
                  "div",
                  {
                    staticClass: "checkbox-group",
                    staticStyle: { display: "grid", gap: "10px" },
                  },
                  [
                    _c("label", [
                      _c("input", {
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: _vm.form.permissions.deleteTask.includes(
                            _vm.selectedUser._id
                          ),
                        },
                        on: {
                          change: function ($event) {
                            return _vm.togglePermission(
                              "deleteTask",
                              _vm.selectedUser._id
                            )
                          },
                        },
                      }),
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("task.deleteCard")) +
                          "\n                "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("label", [
                      _c("input", {
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: _vm.form.permissions.createTask.includes(
                            _vm.selectedUser._id
                          ),
                        },
                        on: {
                          change: function ($event) {
                            return _vm.togglePermission(
                              "createTask",
                              _vm.selectedUser._id
                            )
                          },
                        },
                      }),
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("task.createCard")) +
                          "\n                "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("label", [
                      _c("input", {
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: _vm.form.permissions.editTask.includes(
                            _vm.selectedUser._id
                          ),
                        },
                        on: {
                          change: function ($event) {
                            return _vm.togglePermission(
                              "editTask",
                              _vm.selectedUser._id
                            )
                          },
                        },
                      }),
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("task.editCard")) +
                          "\n                "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("label", [
                      _c("input", {
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: _vm.form.permissions.draggingTask.includes(
                            _vm.selectedUser._id
                          ),
                        },
                        on: {
                          change: function ($event) {
                            return _vm.togglePermission(
                              "draggingTask",
                              _vm.selectedUser._id
                            )
                          },
                        },
                      }),
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("task.dragCard")) +
                          "\n                "
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "flex",
                      "justify-content": "space-around",
                    },
                  },
                  [
                    _c(
                      "SupsisButton",
                      {
                        staticStyle: {
                          "margin-top": "20px",
                          cursor: "pointer",
                        },
                        on: { click: _vm.hideModal },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$t("search.cancelBtn")) +
                            "\n                "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "SupsisButton",
                      {
                        staticStyle: {
                          "margin-top": "20px",
                          cursor: "pointer",
                        },
                        on: { click: _vm.handleSave },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$t("message.save")) +
                            "\n                "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }